/**
 * 脱敏后的支付服务商订阅摘要。
 * 交易详情只允许使用此摘要，不把扩展 JSON 或通讯配置传到页面。
 */
export interface PaymentProviderOption {
  pasId: number;
  providerName: string;
  applicationName: string;
  applicationCode: string;
  validFrom?: string;
  validTo?: string;
  available: boolean;
  current: boolean;
  unavailableReason?: string;
}

/**
 * 交易创建时保存的脱敏支付服务商快照。
 * 与当前医院可选订阅分开，详情页只消费订单接口返回的历史快照。
 */
export interface OrderPaymentProviderSnapshot {
  providerName: string;
  applicationName: string;
  applicationCode: string;
  driverSummary?: string;
}

export interface OrderSettlementSummary {
  settlementCode?: string;
  status?: string;
  cash?: string;
  /** 与 cash 同源同值的结算总额字段，接口单独返回，避免静默丢弃。 */
  totalCash?: string;
  medicalInsuranceCash?: string;
  personalAccountCash?: string;
  selfPayCash?: string;
  remark?: string;
  /**
   * 第三方医保结算原始报文，仅管理端订单详情返回，医院端订单详情不含该字段。
   * 键名与嵌套结构由第三方协议定义，按快照原样展示，不做键名转换或脱敏。
   */
  rawExtend?: Record<string, unknown>;
}

export interface OrderRefundItem {
  detailId: number | string;
  detailType?: string;
  name?: string;
  refundableCount: string;
  refundableCash: string;
}

export interface OrderRefundCapability {
  supported: boolean;
  reason?: string;
  items: OrderRefundItem[];
}

export interface OrderRefundPreview {
  orderId: number;
  paymentId: number;
  items: OrderRefundItem[];
  refundableCash: string;
}

export interface OrderRefundBatchResult {
  batchNo: string;
  status: string;
  flows: Array<Record<string, unknown>>;
}

export interface OrderAggregateDetail {
  order: Record<string, unknown>;
  details: Array<Record<string, unknown>>;
  paymentOrders: Array<Record<string, unknown>>;
  paymentFlows: Array<Record<string, unknown>>;
  refundDetails: Array<Record<string, unknown>>;
  refundCapability: OrderRefundCapability;
  settlementSummary?: OrderSettlementSummary;
  provider?: OrderPaymentProviderSnapshot;
}
